// extracted by mini-css-extract-plugin
module.exports = {"container":"_normal--container--2QaSF","preventDesktopBehaviour":"_normal--preventDesktopBehaviour--1bre4"};